import { FileUploadService } from './../../file-upload.service';
import { LoginService } from './../../service/login.service';
import { FileUpload } from './../../service/FileUpload/fileUpload';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent {
userDetails:any;  msg1:string;currentUpload:any;
msg="enter valid";
delete1:boolean=false;
editId:any;

selectedFile:File=null;path:string='USER';
  constructor(private ApiService:LoginService,private UploadService:FileUploadService) {
    this.userDetails=JSON.parse(localStorage.getItem('username'));
  console.log(this.userDetails) 
  this.getuser();
  }
  getuser()
  {
    this.ApiService.getMemberDetail(this.userDetails.id).then((res)=>
    {
      this.userDetails=res;
      console.log(res)
    })
  }
  showPreview(event:any)
  {
    if(event.target.files && event.target.files[0])
    {
      
      const reader=new FileReader();
        reader.onload=(e:any)=>this.userDetails.image.url=e.target.result;
        reader.readAsDataURL(event.target.files[0]);
        this.selectedFile=event.target.files[0];
        console.log(this.selectedFile);
      this.detectFiles(event);
    }
    else
    {
      this.userDetails.image.url="https://www.linuxtrainingacademy.com/wp-content/plugins/all-in-one-seo-pack/images/default-user-image.png";
    }
  }
  detectFiles(event:any) {
    // this.currentUpload=null;
    
    this.deletePreviousFile();
    this.uploadSingle(event);
  } 
  uploadSingle(event)
  {
    this.currentUpload = new FileUpload(this.selectedFile);
    console.log(this.currentUpload);
    this.UploadService.pushUpload(this.currentUpload,this.path).then((res) => {
      this.userDetails.image = res;
      this.delete1=true
      
      this.currentUpload=null;
      console.log(this.userDetails.image);
      console.log(this.UploadService.uploadPercentage);
    });
  }
  delete()
  {
    this.deletePreviousFile();
    
  }
  deletePreviousFile()
  {
    if(this.userDetails.image.name!=undefined)
    {
      this.UploadService.deleteUpload(this.userDetails.image,this.path).then((res)=>
      {
        console.log('Previous Image Deleted');
        this.userDetails.image.url="https://www.linuxtrainingacademy.com/wp-content/plugins/all-in-one-seo-pack/images/default-user-image.png";
this.delete1=false
      })
    }
  }
  UpdateMember()
  {
  
   this.ApiService.editMemberDetail(this.userDetails.id,this.userDetails).then(
      (res)=>
      {
        console.log(res);
        console.log("updated");
        this.userDetails=this.userDetails

        location.reload()
      }
    );

  console.log(this.userDetails);
    }
}
